import { DatePipe } from './date.pipe';
import { MonthNamePipe } from './month-name.pipe';

export const DATE_PIPE_DECLARATIONS = [DatePipe, MonthNamePipe];

export * from './date.pipe';
export * from './month-name.pipe';
